export enum ERoleDisplayName {
    GROUP_OWNER = 'Group owner',
    GROUP_ADMINISTRATIVE_ASSISTANT = 'Administrative assistant',
    GROUP_CLINICAL_ASSISTANT = 'Clinical assistant (MA) ',
    GROUP_PRACTICE_MANAGER = 'Practice manager',
    GROUP_PROVIDER = 'Provider',
}

export enum ERoleCode {
    GROUP_OWNER = 'GROUP_OWNER',
    GROUP_PROVIDER = 'GROUP_PROVIDER',
    GROUP_ADMINISTRATIVE_ASSISTANT = 'GROUP_ADMINISTRATIVE_ASSISTANT',
    GROUP_CLINICAL_ASSISTANT = 'GROUP_CLINICAL_ASSISTANT',
    GROUP_PRACTICE_MANAGER = 'GROUP_PRACTICE_MANAGER',
}

